// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes shimmer-loading{0%{background-position:200% 0}100%{background-position:-200% 0}}.dropdown-row-slider{width:225px}.dropdown-row-slider:active{color:var(--bs-dropdown-link-color);background-color:var(--bs-dropdown-link-hover-bg)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
